import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { connectionLabel, type ConnectionState } from './connectionState';

const halo = (color: string): string =>
  `0 0 0 3px color-mix(in srgb, ${color} 18%, transparent)`;

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalSNudge,
    fontSize: '12.5px',
    color: tokens.colorNeutralForeground3,
    whiteSpace: 'nowrap',
  },
  dot: {
    width: '8px',
    height: '8px',
    flexShrink: 0,
    borderRadius: tokens.borderRadiusCircular,
  },
  online: {
    backgroundColor: tokens.colorStatusSuccessBackground3,
    boxShadow: halo(tokens.colorStatusSuccessBackground3),
  },
  limited: {
    backgroundColor: tokens.colorStatusWarningBackground3,
    boxShadow: halo(tokens.colorStatusWarningBackground3),
  },
  offline: {
    backgroundColor: tokens.colorStatusDangerBackground3,
    boxShadow: halo(tokens.colorStatusDangerBackground3),
  },
});

interface ConnectionStatusProps {
  state: ConnectionState;
}

const ConnectionStatus = ({ state }: ConnectionStatusProps) => {
  const styles = useStyles();
  return (
    <span data-layout-offline="" className={styles.root}>
      <span className={mergeClasses(styles.dot, styles[state])} />
      <span data-layout-offline-label="">{connectionLabel(state)}</span>
    </span>
  );
};

export default ConnectionStatus;
